import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { OrquestadorService } from 'src/app/services/general/orquestador.service';
import { environment } from 'src/environments/environment';
import { SarlaftResume } from '../models/sarlaft';
import { Pay } from '../models/pay';
import { Payurl } from '../models/payurl';
import { ListPhone, QuotePhoneList } from '../models/resume';
import { Store } from '@ngrx/store';
import { selectsessionId } from '../storage/property.selectors';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SarlaftService {

  static orquestadorService: OrquestadorService;
  
  baseurl = environment.URL_MULESOFT_ORQUESTADOR_INQUILINO;

  constructor(
    private store: Store,
    private orquestadorService: OrquestadorService,
    private http: HttpClient,
    private authService: AuthService
  ) {
    SarlaftService.orquestadorService = orquestadorService;
    this.orquestadorService.setBaseUrl(environment.URL_MULESOFT_ORQUESTADOR_SARLAFT);
  }

  /**
   * Realiza una petición POST con autenticación automática usando OrquestadorService
   * @param body - Cuerpo de la petición
   * @param errorHandler - Manejador de errores opcional
   * @returns Observable con la respuesta
   */
  private makeAuthenticatedOrquestradorRequest<T>(body: any, errorHandler?: (error: any) => void): Observable<T> {
    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        // Log headers in a readable format
       

        return this.orquestadorService.generalOrquestador(body, headers, errorHandler).pipe(
          tap((response: any) => {
          
          })
        );
      })
    );
  }

  /**
   * Realiza una petición POST con autenticación automática directa
   * @param body - Cuerpo de la petición
   * @param url - URL específica para la petición (opcional, usa baseurl por defecto)
   * @returns Observable con la respuesta
   */
  private makeAuthenticatedRequest<T>(body: any, url?: string): Observable<T> {
    const requestUrl = url || this.baseurl;
    
    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        const requestBody = JSON.stringify(body);
        const parsedBody = JSON.parse(requestBody);
        return this.http.post<T>(requestUrl, parsedBody, { headers });
      })
    );
  }

  /**
   * Realiza una petición POST con autenticación automática y validaciones específicas
   * @param body - Cuerpo de la petición
   * @param url - URL específica para la petición (opcional, usa baseurl por defecto)
   * @returns Observable con la respuesta validada
   */
  private makeAuthenticatedRequestWithValidation<T>(body: any, url?: string): Observable<T | { error: boolean; message: any; status: any }> {
    const requestUrl = url || this.baseurl;
    
    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        // Log headers in a readable format
      

        console.log('body tenant', body);

        const requestBody = JSON.stringify(body);
        const parsedBody = JSON.parse(requestBody);
        
        return this.http.post<any>(requestUrl, parsedBody, { headers, observe: 'response' }).pipe(
          map(response => {
            console.log('BASE_URL', requestUrl);
            console.log('respuesta 1' + JSON.stringify(response));
            if (response && response.body.data && response.body.error === false) {
              console.log('respuesta 2' + JSON.stringify(response.body.data));
              return response.body.data;
            } else if (response.body.error === true) {
              console.log('respuesta 3' + JSON.stringify(response.body.data));
              throw { error: true, message: response.body.data.message || response.body.data.Reason, status: response.status };
            } else {
              return response;
            }
          }),
          catchError(error => {
            console.error('Error in request: error DDDDD', error);
            const errorMessage = error.message || error.Reason || 'Unknown';
            return of({ error: true, message: errorMessage, status: error.status });
          })
        );
      }),
      catchError(error => {
        console.error('Error in request: GGGGGG', error);
        return of({ error: true, message: error.message || 'Unknown error', status: error.status || 500 });
      })
    );
  }

  /**
   * Solicitud inicial
   * @param body - Cuerpo de la petición
   * @param errorHandler - Manejador de errores opcional
   * @returns Observable con la respuesta
   */
  initialRequest(body = { quoteId: '', getInitialDataPago: true }, errorHandler?: (error: any) => void): Observable<any> {
    console.log('Orquestador general initial Request');
    return this.makeAuthenticatedOrquestradorRequest<any>(body, errorHandler);
  }

  /**
   * Servicio de pago
   * @param body - Cuerpo de la petición
   * @param ParamsessionId - ID de sesión (opcional, mantenido para compatibilidad)
   * @returns Observable con la respuesta
   */
  payService(body = {}, ParamsessionId?: string): Observable<any> {
    console.log('Orquestador general payService');
    return this.makeAuthenticatedOrquestradorRequest<any>(body);
  }

  /**
   * Servicio de URL de pago
   * @param body - Cuerpo de la petición
   * @param ParamsessionId - ID de sesión (opcional, mantenido para compatibilidad)
   * @returns Observable con la respuesta
   */
  payUrlService(body = {}, ParamsessionId?: string): Observable<any> {
    console.log('Orquestador payUrlService');
    return this.makeAuthenticatedOrquestradorRequest<any>(body);
  }

  /**
   * Servicio de lista de teléfonos
   * @param body - Cuerpo de la petición
   * @param sessionId - ID de sesión (opcional, mantenido para compatibilidad)
   * @returns Observable con la respuesta
   */
  ListPhoneService(body = {}, sessionId?: string): Observable<QuotePhoneList> {
    console.log('Orquestador general ListPhoneService');
    return this.makeAuthenticatedOrquestradorRequest<QuotePhoneList>(body);
  }

  /**
   * Servicio de obtener opciones
   * @param body - Cuerpo de la petición
   * @returns Observable con la respuesta
   */
  getoptService(body: any): Observable<any> {
    console.log('Orquestador getoptService');
    return this.makeAuthenticatedOrquestradorRequest<any>(body);
  }

  /**
   * Servicio general
   * @param body - Cuerpo de la petición
   * @returns Observable con la respuesta
   */
  generalService(body: any): Observable<any> {
    console.log('Orquestador general service');
    console.log('general service static' + JSON.stringify(body));

    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        // Log headers in a readable format
        

        return SarlaftService.orquestadorService.generalOrquestador(body, headers).pipe(
          tap((response: any) => {
            console.log('body', body);
            console.log('response quote', response);
          })
        );
      })
    );
  }

  /**
   * Servicio para contratos de resumen de arrendamiento
   * @param body - Cuerpo de la petición
   * @param ParamsessionId - ID de sesión (opcional, mantenido para compatibilidad)
   * @returns Observable con la respuesta
   */
  Lease_orchesResumesContract(body: any, ParamsessionId?: string): Observable<any> {
    return this.makeAuthenticatedRequestWithValidation<any>(body);
  }

  /**
   * Métodos adicionales para gestión de token de auth
   */
  public isTokenValid(): Observable<boolean> {
    return this.authService.isTokenValid();
  }

  public refreshToken(): void {
    this.authService.refreshToken();
  }

  public clearToken(): void {
    this.authService.clearToken();
  }
}